import logo from './logo.svg';
import './App.css';
import PageRouter from './routes/PageRouter';

function App() {
  return (
    <>
    <PageRouter/>
    </>
  );
}

export default App;
